export const steps = {
  REGISTRATION_TYPE: 0,
  EMAIL_INPUT: 1,
  LANGUAGE_SELECTION: 2,
  PERSONAL_DETAILS: 3,
  MEMBERSHIP_PLAN: 4,
  TERMS_CONDITIONS: 5,
  DIGITAL_SIGNATURE: 6,
  SEND_CONFIRMATION: 7,
  SUCCESS_SCREEN: 8,
};

export const registrationTypes = {
  English: ['Personal Training', 'Fitness'],
  Dutch: ['Persoonlijke Training', 'Fitness'],
};

export const languages = ['English', 'Dutch'];

export const translations = {
  English: {
    selectRegistrationType: 'Select Registration Type',
    enterAdminEmailAddress: 'Email for Administration Purposes.',
    enterAgendaEmailAddress: 'Email for Agenda Purposes',
    enterEmailAddress: 'Enter Email Address',
    pleaseEnterEmail: 'Please enter your email address:',
    selectPreferredLanguage: 'Select Preferred Language',
    personalDetails: 'Personal Details',
    pleaseFillPersonalDetails: 'Please fill in your personal details:',
    companyName: 'Company Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    streetName: 'Street Name',
    houseNumber: 'House Number',
    houseNumberAddition: 'House Number Addition',
    postalCode: 'Postal Code',
    city: 'City',
    email: 'Email',
    phone: 'Phone',
    dateOfBirth: 'Date of Birth',
    membershipPlan: 'Membership Plan',
    package: 'Package',
    futurePackage: 'Future Package',
    sixWeekProgram: 'Prepaid six week program',
    iUnderstandSixProgram: 'I understand that after the 6-week program, I can choose to continue at €X per session. \n There is no automatic renewal. After 6 weeks I decide whether I want to continue.',
    sessionDuration: 'Session Duration (minutes)',
    price: 'Price (€)',
    location: 'Location',
    editLocations: 'Edit Locations',
    existingLocations: 'Existing Locations',
    remove: 'Remove',
    addLocation: 'Add Location',
    cancel: 'Cancel',
    termsConditions: 'Terms & Conditions',
    pleaseReadTerms: 'Here are the terms and conditions...\nPlease read them carefully before agreeing.\n[Insert full terms and conditions text here.]',
    iUnderstandAgree: 'I understand and agree',
    alsoSignPtQuestion: 'Do you also want to sign the terms and conditions for Personal Training?',
    pleaseAgreeToTerms: 'Please agree to the terms and conditions',
    errorLoadingTerms: 'The terms and conditions could not be loaded',
    digitalSignature: 'Digital Signature',
    Signature: 'Signature',
    pleaseSign: 'Please sign using your finger in the box below:',
    clear: 'Clear',
    done: 'Done',
    confirmEmailAddress: 'Confirm Email Address',
    pleaseConfirmEmail: 'Please confirm your email address:',
    confirm: 'Confirm',
    emailConfirmedPreparing: 'Email confirmed. Preparing success screen...',
    success: 'Success!',
    registrationSubmitted: 'The registration form has been submitted successfully.',
    returningDashboard: 'Returning to the main dashboard...',
    cancelRegistration: 'Cancel Registration',
    cancelRegistrationConfirm: 'Are you sure you want to cancel the registration?',
    next: 'Next',
    back: 'Back',
    submit: 'Submit',
    doneButton: 'Done',
    selectPlan: 'Select a plan',
    selectDuration: 'Select duration',
    selectPrice: 'Select price',
    selectLocation: 'Select location',
    locationNameCannotBeEmpty: 'Location name cannot be empty',
    yourEmail: 'Your Email',
    confirmYourEmail: 'Confirm Your Email',
    selectPersona: 'Select Persona',
    pleaseSelectPersona: 'Please Select Persona',
    selectGoals: 'Select Goals',
    pleaseSelectGoals: 'Select one or more goals for the client:',
    pleaseSelectGoal: 'Please select at least one goal',
    pleaseEnterCustomGoal: 'Please enter a custom goal',
    enterCustomGoal: 'Enter custom goal...',
    'Weight Loss': 'Weight Loss',
    'Build Muscle': 'Build Muscle',
    'Move without pain': 'Move without pain',
    'Performance/productivity': 'Performance/productivity',
    'Improve Fitness & Energy': 'Fitter & Energieker worden',
    'Other': 'Other',
    reEnterEmail: 'ReEnter Email',
    confirmAndSend: 'Confirm And Send',
    confirmCancellation:'Confirm Cancellation',
    cancelRegistrationConfirmation: 'Are you sure you want to cancel this registration?',
    yes: 'Yes',
    no: 'No',
    changeSignature: 'Change Signature',
    addSignature: 'Add Signature',
    'The email is already registered': 'The email is already registered',
    'Send Email': 'Send Email',
    'The undersigned (parent/guardian of)': 'The undersigned (parent/guardian of)',
    'Last name': 'Last name',
    'First name': 'First name',
    'Street name + house number': 'Street name + house number',
    'Postal code': 'Postal code',
    'City': 'City',
    'Phone number': 'Phone number',
    'Date of birth': 'Date of birth',
    'Email address': 'Email address',
    'hereby declares that the above information has been filled in truthfully, has taken note of the prices for the services to be agreed upon, and has reached the following agreement with Joeri Zwart:': 'hereby declares that the above information has been filled in truthfully, has taken note of the prices for the services to be agreed upon, and has reached the following agreement with Joeri Zwart:'
  },
  Dutch: {
    selectRegistrationType: 'Selecteer Registratietype',
    enterEmailAddress: 'Voer E-mailadres in',
    enterAdminEmailAddress: 'E-mailadres voor administratieve doeleinden',
    enterAgendaEmailAddress: 'E-mail ten behoeve van de agenda',
    pleaseEnterEmail: 'Voer uw e-mailadres in:',
    selectPreferredLanguage: 'Selecteer Voorkeurstaal',
    personalDetails: 'Persoonlijke Gegevens',
    pleaseFillPersonalDetails: 'Vul uw persoonlijke gegevens in:',
    companyName: 'Bedrijfsnaam',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    streetName: 'Straatnaam',
    houseNumber: 'Huisnummer',
    houseNumberAddition: 'Huisnummer Toevoeging',
    postalCode: 'Postcode',
    city: 'Plaats',
    email: 'E-mail',
    phone: 'Telefoon',
    dateOfBirth: 'Geboortedatum',
    membershipPlan: 'Lidmaatschapsplan',
    package: 'Pakket',
    futurePackage: 'Toekomstpakket',
    sixWeekProgram: 'Vooruibetaald zes weken programma',
    iUnderstandSixProgram: 'Ik begrijp dat ik na het 6-weekse programma kan kiezen om door te gaan tegen €X per sessie. \n Er vindt geen automatische verlenging plaats. Na 6 weken bepaal ik zelf of ik wil doorgaan.',
    sessionDuration: 'Sessie Duur (minuten)',
    price: 'Prijs (€)',
    location: 'Locatie',
    editLocations: 'Locaties Bewerken',
    existingLocations: 'Bestaande Locaties',
    remove: 'Verwijderen',
    addLocation: 'Locatie Toevoegen',
    cancel: 'Annuleren',
    termsConditions: 'Algemene Voorwaarden',
    pleaseReadTerms: 'Hier zijn de algemene voorwaarden...\nLees ze zorgvuldig door voordat u akkoord gaat.\n[Voeg volledige algemene voorwaarden hier in.]',
    iUnderstandAgree: 'Ik begrijp het en ga akkoord',
    alsoSignPtQuestion: 'Wil je ook de algemene voorwaarden voor Personal Training ondertekenen?',
    pleaseAgreeToTerms: 'Ga akkoord met de algemene voorwaarden',
    errorLoadingTerms: 'De algemene voorwaarden konden niet worden geladen',
    digitalSignature: 'Digitale Handtekening',
    Signature: 'Handtekening',
    pleaseSign: 'Onderteken met uw vinger in het onderstaande vak:',
    clear: 'Wissen',
    done: 'Klaar',
    confirmEmailAddress: 'Bevestig E-mailadres',
    pleaseConfirmEmail: 'Bevestig uw e-mailadres:',
    confirm: 'Bevestigen',
    emailConfirmedPreparing: 'E-mail bevestigd. Voorbereiden succes scherm...',
    success: 'Succes!',
    registrationSubmitted: 'Het registratieformulier is succesvol ingediend.',
    returningDashboard: 'Terugkeren naar het hoofdscherm...',
    cancelRegistration: 'Registratie Annuleren',
    cancelRegistrationConfirm: 'Weet u zeker dat u de registratie wilt annuleren?',
    next: 'Volgende',
    back: 'Terug',
    submit: 'Verzenden',
    doneButton: 'Klaar',
    selectPlan: 'Selecteer een plan',
    selectDuration: 'Selecteer duur',
    selectPrice: 'Selecteer prijs',
    selectLocation: 'Selecteer locatie',
    locationNameCannotBeEmpty: 'Locatienaam mag niet leeg zijn',
    yourEmail: 'Uw e-mailadres',
    confirmYourEmail: 'Bevestig uw e-mailadres',
    selectPersona: 'Selecteer Persona',
    pleaseSelectPersona: 'Selecteer een persona',
    selectGoals: 'Selecteer Doelen',
    pleaseSelectGoals: 'Selecteer een of meer doelen voor de cliënt:',
    pleaseSelectGoal: 'Selecteer ten minste één doel',
    pleaseEnterCustomGoal: 'Voer een aangepast doel in',
    enterCustomGoal: 'Voer aangepast doel in...',
    'Weight Loss': 'Afvallen',
    'Build Muscle': 'Spiermassa opbouwen',
    'Move without pain': 'Pijnvrij bewegen',
    'Performance/productivity': 'Productiviteit/prestaties',
    'Improve Fitness & Energy': 'Fitter & Energieker worden',
    'Other': 'Anders',
    reEnterEmail: 'E-mailadres opnieuw invoeren',
    confirmAndSend: 'Bevestigen en verzenden',
    confirmCancellation:'Annulering bevestigen',
    cancelRegistrationConfirmation: 'Weet u zeker dat u deze registratie wilt annuleren?',
    yes: 'Ja',
    no: 'Nee',
    changeSignature: 'Handtekening wijzigen',
    addSignature: 'Handtekening toevoegen',
    'The email is already registered': 'Het e-mailadres is al geregistreerd',
    'Send Email': 'E-mail verzenden',
    'The undersigned (parent/guardian of)': 'De ondergetekende (ouder/verzorger van)',
    'Last name': 'Achternaam',
    'First name': 'Voornaam',
    'Street name + house number': 'Staatnaam + huisnummer',
    'Postal code': 'Postcode',
    'City': 'Woonplaats',
    'Phone number': 'Telefoonnummer',
    'Date of birth': 'Geboortedatum',
    'Email address': 'Emailadres',
    'hereby declares that the above information has been filled in truthfully, has taken note of the prices for the services to be agreed upon, and has reached the following agreement with Joeri Zwart:': 'verklaart bovenstaande naar waarheid te hebben ingevuld, kennis te hebben genomen van de prijzen voor de af te sluiten diensten en is met Joeri Zwart het volgende overeengekomen:'
  },
};
